import { redondear2 } from './dinero.js';
/** Métodos de precio (SPEC §6.3). Espejo del enum `MetodoPrecio` de Prisma. */
export const METODOS_PRECIO = ['MANUAL', 'PORCENTAJE', 'MULTIPLICADOR', 'SUMA'];
export const ESTILOS_PRECIO = ['SIMPLE', 'ANTES_AHORA'];
/** Factor sugerido para el precio "Antes" cuando el estilo es ANTES_AHORA (SPEC §6.3). */
export const FACTOR_ANTES_SUGERIDO = 1.35;
/**
 * Calcula el precio de venta de un producto para un cliente.
 *
 *   MANUAL        → valor
 *   PORCENTAJE    → costo * (1 + valor/100)     // $25 +40% = $35.00
 *   MULTIPLICADOR → costo * valor               // $25 ×2   = $50.00
 *   SUMA          → costo + valor               // $25 +$10 = $35.00
 */
export function calcularPrecio({ costo, metodo, valor }) {
    if (!Number.isFinite(costo) || costo < 0)
        throw new RangeError(`Costo inválido: ${costo}`);
    if (!Number.isFinite(valor))
        throw new RangeError(`Valor inválido: ${valor}`);
    switch (metodo) {
        case 'MANUAL':
            return redondear2(valor);
        case 'PORCENTAJE':
            return redondear2(costo * (1 + valor / 100));
        case 'MULTIPLICADOR':
            return redondear2(costo * valor);
        case 'SUMA':
            return redondear2(costo + valor);
    }
}
/** Precio "Antes" sugerido a partir del "Ahora". El usuario puede editarlo después. */
export function sugerirPrecioAntes(precioAhora) {
    return redondear2(precioAhora * FACTOR_ANTES_SUGERIDO);
}
/** Formato de vitrina. `decimales` viene del elemento `precio` de la plantilla. */
export function formatearPrecio(valor, opciones = {}) {
    const { prefijo = '$', decimales = 2 } = opciones;
    const n = redondear2(valor);
    const texto = decimales === 0 ? String(Math.round(n)) : n.toFixed(2);
    return `${prefijo}${texto}`;
}
//# sourceMappingURL=pricing.js.map